import * as ApiManager from './_manager';
import store from '@/store';

export const program = {
  create: (payload = null) => {
    console.log('payload ---<<<', payload)
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/program/create`,
      payload
    );
  },

  get: (payload = null) => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/program/get`,
      payload
    );
  },

  list: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/program/list`,
      payload
    );
  },

  delete: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/program/${payload.id}/delete`,
      payload
    );
  },

  update: payload => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/program/` +
        payload.id +
        `/update`,
      payload
    );
  },
};
